const styles = {
    iframeStyle: {
        width: '100vw',
        height: '1200px'
    }
};

export default styles;